import ButtonWithIcon from 'components/ButtonWithIcon';
import CalculatePurpleIcon from 'assets/icons/calculate-purple.svg';
import ChartsFormTextField from './ChartsFormTextField';
import ClosePurpleIcon from 'assets/icons/close-purple.svg';
import { ChartsFormActionsProps } from 'interfaces/components/chartsFormNestedFields';

const ChartsFormNestedFields = ({
  showNestedFields,
  nestedFields,
  getFieldValue,
  handleFieldChange,
  handleCalculateButtonClick,
  annualRevenue
}: ChartsFormActionsProps) => {
  const showCalculateButton = Boolean(
    nestedFields?.length && nestedFields.length > 0
  );

  return showCalculateButton ? (
    <div
      className={`flex flex-col overflow-hidden transition-all duration-300 ease-in-out ${
        showNestedFields
          ? 'w-full rounded-lg border border-purple-700/10'
          : 'h-8'
      }`}
    >
      <ButtonWithIcon
        id='chart_form_calculate_button'
        prefixIcon={CalculatePurpleIcon}
        prefixIconAlt='Calculate Icon'
        label='Calculate'
        {...(showNestedFields && {
          suffixIcon: ClosePurpleIcon,
          suffixIconAlt: 'Close Icon'
        })}
        className={`bg-[#F3F3FC] dark:text-black ${
          showNestedFields
            ? 'p-2'
            : 'h-8 pl-[8px] pr-[15px] rounded-lg border border-purple-700/10'
        } flex gap-1 flex-row items-center justify-between cursor-pointer hover:bg-purple-200 transition-all duration-300 ease-in-out`}
        textStyle={`text-[${
          showNestedFields ? '14' : '16'
        }px] leading-[16px] font-semibold text-purple-700 transition-all duration-300`}
        onClick={handleCalculateButtonClick}
      />
      {showNestedFields && (
        <div className='flex flex-col gap-4 p-2 transition-all duration-300 ease-in-out transform origin-top'>
          {nestedFields?.map(field => (
            <ChartsFormTextField
              key={`chart-form-text-field-${field.name}`}
              field={field}
              disabled={false}
              getFieldValue={getFieldValue}
              handleFieldChange={handleFieldChange}
              annualRevenue={annualRevenue}
            />
          ))}
        </div>
      )}
    </div>
  ) : null;
};

export default ChartsFormNestedFields;
